export const PROJECTS_REFRESH_EVENT = 'projects:refresh';

export const refreshProjects = () => {
  window.dispatchEvent(new CustomEvent(PROJECTS_REFRESH_EVENT));
};
